import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Sparkles, Scale } from '../../icons';
import Sheet from '../ui/Sheet';
import Button from '../ui/Button';

const AnalysisModal = ({
  isOpen,
  onClose,
  content,
  isLoading = false,
  type = 'analysis', // 'analysis' or 'comparison'
  propertyName = '',
}) => {
  const Icon = type === 'comparison' ? Scale : Sparkles;
  const baseTitle = type === 'comparison' ? 'Comparison' : 'AI Analysis';

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      mode="sheet"
      size="lg"
      title={baseTitle}
      subtitle={propertyName || undefined}
      aria-label={baseTitle}
      headerLeft={
        <span className="mt-1.5 w-10 h-10 rounded-xl bg-accent-soft text-accent flex items-center justify-center flex-shrink-0">
          <Icon className="w-5 h-5" />
        </span>
      }
      footer={
        <div className="flex justify-end">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      }
    >
      {isLoading ? (
        <div className="flex flex-col items-center justify-center py-14 gap-3 text-secondary">
          <span className="w-10 h-10 rounded-full border-2 border-line border-t-accent animate-spin" />
          <span className="text-sm">{type === 'comparison' ? 'Comparing properties…' : 'Analyzing property…'}</span>
        </div>
      ) : (
        <div className="prose-dark">
          <ReactMarkdown>{content || `No ${type} available.`}</ReactMarkdown>
        </div>
      )}
    </Sheet>
  );
};

export default AnalysisModal;
